export default __webpack_public_path__ + "static/media/red-cross-logo1.a5dfb03c.jpg";